import { Box, FormGroup } from '@mui/material';
import { styled } from '@mui/material/styles';
import { IconedBox } from 'views/common/components/UI/MainWidget';

interface StyledProps {
  pickupSelected?: boolean;
  disabled?: boolean;
}
const StyledBox = styled(Box)<StyledProps>(({ theme, pickupSelected }) => ({
  borderRadius: theme.spacing(0.5),
  border: `1px solid ${theme.palette.divider[7]}`,
  position: 'relative',
  zIndex: 3,
  width: 'fit-content',
  [theme.breakpoints.between(1330, 1450)]: {
    maxWidth: theme.typography.pxToRem(1150),
  },
  [theme.breakpoints.down('xl')]: {
    width: '100%',
  },
  [theme.breakpoints.down('lg')]: {
    border: 0,
    borderRadius: 0,
    borderBottom: `1px solid ${theme.palette.divider[7]}`,
    background: 'unset',
    backdropFilter: 'unset',
    position: 'relative',
    zIndex: theme.zIndex.appBar,

  },
  '& .GWSFlexContainer': {
    transition: 'all .2s',
    [theme.breakpoints.down('md')]: {
      overflow: 'hidden',
    },
  },
  '& .GWSAutoLocationsContainer': {
    [theme.breakpoints.up('lg')]: {
      minWidth: theme.typography.pxToRem(300),
      flex: '1 0 0',
    },

    [theme.breakpoints.up('xl')]: {
      minWidth: theme.typography.pxToRem(540),
    },
    [theme.breakpoints.between(1330, 1650)]: {
      minWidth: theme.typography.pxToRem(390),
    },
    alignItems: 'center',
    display: 'flex',
    transition: 'all .2s',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(1),
      flex: '1 1 auto',
    },
  },
  '& .GWSlocInput': {
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      width: pickupSelected ? '50%' : '100%',
    },
  },
  '& .GWSReturnContainer': {
    [theme.breakpoints.up('lg')]: {
      width: pickupSelected ? '50%' : '0',
    },
    '& .MuiFormControlLabel-label': {
      fontSize: theme.typography.pxToRem(14),
      marginRight: 0,
    },
  },
  '& .GWSReturn': {
    position: 'relative',
    height: '100%',
    paddingLeft: theme.spacing(1),
    '&::before, &::after': {
      borderColor: 'transparent !important',
    },
    '& label': {
      height: '100%',
    },
  },
  '& .GWSVehicleType': {
    [theme.breakpoints.up('xl')]: {
      width: theme.typography.pxToRem(193),
    },

    [theme.breakpoints.between('lg', 'xl')]: {
      width: theme.typography.pxToRem(177),
    },

    '&.GWVModel': {
      [theme.breakpoints.up('xl')]: {
        width: theme.typography.pxToRem(270),
      },
      [theme.breakpoints.between(1330, 1600)]: {
        width: `${theme.typography.pxToRem(193)} !important`,
      },
    },
    '&:last-child': {
      paddingRight: 0,
      borderRight: 0,
    },
  },
  '& .fullHeight': {
    height: '100%',
  },
  '& .GWSAutoComplete': {
    height: '100%',
    '& .MuiSvgIcon-root': {
      fill: theme.palette.common.white,
    },
  },
  '& .GWSGridItem': {
    position: 'relative',
    transition: 'all .2s',
    [theme.breakpoints.up('md')]: {
      borderRight: `1px solid ${theme.palette.divider[7]}`,
    },
    [theme.breakpoints.down('lg')]: {
      width: '50%',
      '&:nth-child(2)::after': {
        width: 0,
      },
      '&:last-child': {
        borderRight: 0,
      },
    },
    [theme.breakpoints.down('md')]: {
      '&:nth-child(1)::after': {
        width: 0,
      },
    },
  },
  '& .GWSFieldHolder': {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  '& .GWSRangePicker': {
    [theme.breakpoints.up('lg')]: {
      width: theme.typography.pxToRem(190),
    },
    [theme.breakpoints.down('lg')]: {
      flex: '.35 .35 auto',
    },
  },

  '& .GWSRTSLToolTip': {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    cursor: 'not-allowed',
    '& .MuiTouchRipple-root': {
      display: 'none',
    },
  },
}));

export const StyledIconedBox = styled(IconedBox)(({ theme, disabled }) => ({
  '& .IBIcon': {
    left: theme.spacing(3),
    [theme.breakpoints.between('lg', 'xl')]: {
      left: theme.spacing(2),
    },
  },
  '&:hover .IBIcon path,& .IBIcon path': {
    fill: disabled ? theme.palette.action.disabled : theme.palette.common.white,
  },
}));

export const StyledFormGroup = styled(FormGroup)<StyledProps>(({ disabled , theme}) => ({
  '& .MuiFormControlLabel-root': {
    opacity: disabled ? '.5' : '1',
  },
  '& .Mui-checked.Mui-disabled':{
    color: theme.palette.primary.light,
  },
}));

export default StyledBox;
